<template>
    <base-table-row v-if="showAllOpen">
        <base-table-cell>
            <div v-if="nextActionDue" class="flex h-5 max-w-10 items-center justify-center">
                <input v-model="isSelected" type="checkbox">
            </div>
            <div v-else class="flex h-5 items-center justify-center">
                --
            </div>
        </base-table-cell>
        <base-table-cell @click.alt="openCrmDetailsInEdit" @click.exact="openCrmDetails" @click.shift="openCompanyModal" class="hover:cursor-pointer">
            <div class="whitespace-nowrap [&:not(:hover)]:truncate hover:whitespace-normal w-28">
                {{ clientName }}
            </div>
        </base-table-cell>
        <base-table-cell  @click.exact="openCrmDetails" @click.shift="openCompanyModal" @click.alt="openCrmDetailsInEdit" class="hover:cursor-pointer">
            <div class="whitespace-nowrap [&:not(:hover)]:truncate hover:whitespace-normal">
                {{ coverageName }}
            </div>
        </base-table-cell>
        <base-table-cell @click.alt="openCrmDetailsInEdit" @click.exact="openCrmDetails" @click.shift="openCompanyModal" class="hover:cursor-pointer">
        <div class="whitespace-nowrap [&:not(:hover)]:truncate hover:whitespace-normal flex items-center justify-between w-64">
            <div class="[&:not(:hover)]:truncate">
                {{ targetName }}
            </div>
            <div v-if="companyLoading" class="w-fit ml-2">
                <PaginationLoader
                    class="rounded-full hover:bg-gray-300"
                    :isLoading="companyLoading"
                    ></PaginationLoader>
            </div>
        </div>
        </base-table-cell>
        <base-table-cell @click.alt="openCrmDetailsInEdit" @click.exact="openCrmDetails" @click.shift="openCompanyModal" class="hover:cursor-pointer">
        <div class="whitespace-nowrap [&:not(:hover)]:truncate hover:whitespace-normal flex items-center justify-between">
            <div class="[&:not(:hover)]:truncate">
                {{ mostRecentStatus }}
            </div>
        </div>
        </base-table-cell>
        <base-table-cell @click.alt="openCrmDetailsInEdit" @click.exact="openCrmDetails" @click.shift="openCompanyModal" class="hover:cursor-pointer flex flex-col">
            <NextStepCell class="border-b border-b-gray-300 mb-1 last:mb-0 pb-0.5 last:border-b-0" v-for="action in allOpenUserActions" :key="action.id" @add-new-next-step="createNewDetail" :next-step="action" :crm-detail-types="crmDetailTypes" />
        </base-table-cell>
        <base-table-cell @click.alt="openCrmDetailsInEdit" @click.exact="openCrmDetails" @click.shift="openCompanyModal" class="hover:cursor-pointer">
            <div v-for="action in allOpenUserActions" :key="action.id" class="border-b border-b-gray-300 mb-1 last:mb-0 pb-0.5 last:border-b-0">
                {{ formatDateTwoDigitYear(action.due_date) }}
            </div>
        </base-table-cell>
        <base-table-cell @click.alt="openCrmDetailsInEdit" @click.exact="openCrmDetails" @click.shift="openCompanyModal" class="hover:cursor-pointer flex flex-col">
            <NextStepDetailsCell class="border-b border-b-gray-300 mb-1 last:mb-0 pb-0.5 last:border-b-0" v-for="action in allOpenUserActions" :key="action.id" @update-next-step="updateNextStep" :next-step="action" />
        </base-table-cell>
        <base-table-cell @click.alt="openCrmDetailsInEdit" @click.exact="openCrmDetails" @click.shift="openCompanyModal" class="hover:cursor-pointer">
            <NextStepResponsibleCell class="border-b border-b-gray-300 mb-1 last:mb-0 pb-0.5 last:border-b-0" @update-next-step="updateNextStep" :next-step="nextActionDue" :user-options="userOptions" />
        </base-table-cell>
        <base-modal :is-form-visible="crmDetailsVisible" @close="closeDetails">
            <template #header>
            <h2 class="text-lg">
                {{ company.company_name }} CRM Details
            </h2>
            </template>
            <template #body>
            <CRMDetailsPage class="text-[0.8rem]" :company="company" :campaigns="campaigns" :crm-statuses="crmStatuses" :crm-action-types="crmDetailTypes" @close="closeDetails" :open-in-edit="openInEdit" @refetch-companies="fetchNewCompanies" @save-and-close="bulkUpdateCompanyCRM" />
            </template>
        </base-modal>
        <base-modal :is-form-visible="companyModalVisible" @close="closeCompanyModal">
          <template #header>
            <h2 class="text-lg">{{ company.company_name }} {{ company.id }}</h2>
          </template>
          <template #body>
            <EditCompany
              :company="company"
              :campaigns="campaigns"
              @close="closeCompanyModal"
              @refetch-companies="fetchNewCompanies"
            />
          </template>
        </base-modal>
    </base-table-row>
    <base-table-row v-else>
        <base-table-cell>
            <div v-if="nextActionDue" class="flex h-5 max-w-10 items-center justify-center">
                <input v-model="isSelected" type="checkbox">
            </div>
            <div v-else class="flex h-5 items-center justify-center">
                --
            </div>
        </base-table-cell>
        <base-table-cell @click.alt="openCrmDetailsInEdit" @click.exact="openCrmDetails" @click.shift="openCompanyModal" class="hover:cursor-pointer">
            <div class="whitespace-nowrap [&:not(:hover)]:truncate hover:whitespace-normal w-28">
                {{ clientName }}
            </div>
        </base-table-cell>
        <base-table-cell  @click.exact="openCrmDetails" @click.shift="openCompanyModal" @click.alt="openCrmDetailsInEdit" class="hover:cursor-pointer">
            <div class="whitespace-nowrap [&:not(:hover)]:truncate hover:whitespace-normal">
                {{ coverageName }}
            </div>
        </base-table-cell>
        <base-table-cell @click.alt="openCrmDetailsInEdit" @click.exact="openCrmDetails" @click.shift="openCompanyModal" class="hover:cursor-pointer">
        <div class="whitespace-nowrap [&:not(:hover)]:truncate hover:whitespace-normal flex items-center justify-between w-64">
            <div class="[&:not(:hover)]:truncate">
                {{ targetName }}
            </div>
            <div v-if="companyLoading" class="w-fit ml-2">
                <PaginationLoader
                    class="rounded-full hover:bg-gray-300"
                    :isLoading="companyLoading"
                    ></PaginationLoader>
            </div>
        </div>
        </base-table-cell>
        <base-table-cell @click.alt="openCrmDetailsInEdit" @click.exact="openCrmDetails" @click.shift="openCompanyModal" class="hover:cursor-pointer">
        <div class="whitespace-nowrap [&:not(:hover)]:truncate hover:whitespace-normal flex items-center justify-between">
            <div class="[&:not(:hover)]:truncate">
                {{ mostRecentStatus }}
            </div>
        </div>
        </base-table-cell>
        <base-table-cell @click.alt="openCrmDetailsInEdit" @click.exact="openCrmDetails" @click.shift="openCompanyModal" class="hover:cursor-pointer">
            <NextStepCell @add-new-next-step="createNewDetail" :next-step="nextActionDue" :crm-detail-types="crmDetailTypes" />
        </base-table-cell>
        <base-table-cell @click.alt="openCrmDetailsInEdit" @click.exact="openCrmDetails" @click.shift="openCompanyModal" class="hover:cursor-pointer">
            <div>
                {{ nextActionDate }}
            </div>
        </base-table-cell>
        <base-table-cell @click.alt="openCrmDetailsInEdit" @click.exact="openCrmDetails" @click.shift="openCompanyModal" class="hover:cursor-pointer">
            <NextStepDetailsCell @update-next-step="updateNextStep" :next-step="nextActionDue" />
        </base-table-cell>
        <base-table-cell @click.alt="openCrmDetailsInEdit" @click.exact="openCrmDetails" @click.shift="openCompanyModal" class="hover:cursor-pointer">
            <NextStepResponsibleCell @update-next-step="updateNextStep" :next-step="nextActionDue" :user-options="userOptions" />
        </base-table-cell>
        <base-modal :is-form-visible="crmDetailsVisible" @close="closeDetails">
            <template #header>
            <h2 class="text-lg">
                {{ company.company_name }} CRM Details
            </h2>
            </template>
            <template #body>
            <CRMDetailsPage class="text-[0.8rem]" :company="company" :campaigns="campaigns" :crm-statuses="crmStatuses" :crm-action-types="crmDetailTypes" @close="closeDetails" :open-in-edit="openInEdit" @refetch-companies="fetchNewCompanies" @save-and-close="bulkUpdateCompanyCRM" />
            </template>
        </base-modal>
        <base-modal :is-form-visible="companyModalVisible" @close="closeCompanyModal">
          <template #header>
            <h2 class="text-lg">{{ company.company_name }} {{ company.id }}</h2>
          </template>
          <template #body>
            <EditCompany
              :company="company"
              :campaigns="campaigns"
              @close="closeCompanyModal"
              @refetch-companies="fetchNewCompanies"
            />
          </template>
        </base-modal>
    </base-table-row>
</template>

<script setup>
import { defineProps, defineEmits, computed, ref, watch } from 'vue';
import NextStepDetailsCell from './NextStepDetailsCell.vue';
import NextStepCell from './NextStepCell.vue';
import NextStepResponsibleCell from './NextStepResponsibleCell.vue';
import CRMDetailsPage from '../CRMDetailsPage.vue';
import { getTodaysDateAsString } from '@/composables/formatDate';
import { sortCRMDetailsByDueDate as sortByDueDate } from '@/composables/CompanyCRMTools';
import { useToast } from 'vue-toast-notification';
import { updateCompanyCRMActions } from '@/services/Company';
import { useStore } from 'vuex';
import PaginationLoader from '../base-components/PaginationLoader.vue';
import { formatDateTwoDigitYear } from '@/composables/formatDate';
import EditCompany from '../EditCompany.vue';

const store = useStore()
const $toast = useToast()
const emit = defineEmits([
    'refetch-companies', 'update-next-step', 'create-new-next-step', 'add-selected-detail', 'remove-selected-detail'
])

const props = defineProps([
    'company', 'crmDetailTypes', 'userOptions', 'campaigns', 'crmStatuses', 'selectedDetails', 'showAllOpen'
])

const companyLoading = ref(false)
const waitingForMoreChanges = ref(false)
const openInEdit = ref(false)

watch(() => props.selectedDetails, () => {
    if(nextActionDue.value){
        if(props.selectedDetails.find((id) => id == nextActionDue.value.id)){
            isSelected.value = true
        } else {
            isSelected.value = false
        }
    }
})

function setCompanyLoading(trueOrFalse){
    companyLoading.value = trueOrFalse
}

function hello(){
    console.log('hello world')
}

const isSelected = ref(false)

watch(isSelected, () => {
    if(isSelected.value){
        emit('add-selected-detail', nextActionDue.value.id)
    } else {
        emit('remove-selected-detail', nextActionDue.value.id)
    }
})

const company = ref(props.company)

const changeCount = ref(0)

function setCompany(companyData){
    company.value = companyData
    // setCompanyLoading(false)
}

watch(props, () => {
    if(props.company) {
        company.value = props.company
    }
})

const crmDetailsVisible = ref(false)
const companyModalVisible = ref(false)

const clientName = computed(() => {
    if(company.value){
        return company.value.campaign.client.client_name
    } else {
        return  '--'
    }
})

const coverageName = computed(() => {
    if(company.value){
        const manager = company.value.campaign.client.active_account_manager
        if(manager && manager.user){
            return `${manager.user.first_name} ${manager.user.last_name}` 
        } else {
            return '--'
        }
    } else {
        return  '--'
    }
})

const allOpenUserActions = computed(() => {
    if(company.value.crm_actions.length > 0){
        let openActions = company.value.crm_actions.filter((action) => {
            return !action.resolved_date && action.campaign_id == company.value.campaign.id && action.user && action.user.id == store.state.auth.user.id
        })
        if(openActions.length > 0){
            openActions = openActions.sort(sortByDueDate)
            return openActions
        } else {
            return []
        }
    } else {
        return []
    }
})

const targetName = computed(() => {
    if(company.value){
        return company.value.company_name
    } else {
        return  '--'
    }
})

const crm_statuses = computed(() => {
    return props.company.crm_statuses.filter(crm_status => crm_status.campaign.id == props.company.campaign.id).sort((a, b) => {
        return new Date(b.created_on) - new Date(a.created_on)
    })
})

const mostRecentStatus = computed(() => {
    if(crm_statuses.value.length > 0){
        let recentStatus = crm_statuses.value.reduce((accumulator, currentValue) =>{
                let accDate = new Date(accumulator.created_on).getTime()
                let currDate = new Date(currentValue.created_on).getTime()
                if(accDate > currDate){
                    return accumulator
                } else {
                    return currentValue
                }
            })
        // console.log('recent status', recentStatus)
        return recentStatus.crm_status.status_name
    } else {
        return "--"
    }
}
)

// const nextStep = computed(() => {
//     if(company.value){
//         return company.value.company_name
//     } else {
//         return  '--'
//     }
// })

function openCrmDetails(){
    crmDetailsVisible.value = true
}

function openCrmDetailsInEdit(){
    openInEdit.value = true
    crmDetailsVisible.value = true
}

function closeDetails(){
    crmDetailsVisible.value = false
    openInEdit.value = false
}


const nextActionDue = computed(() => {
    if(company.value.crm_actions.length > 0){
        let openActions = company.value.crm_actions.filter((action) => {
            return !action.resolved_date && action.campaign_id == company.value.campaign.id && action.user && action.user.id == store.state.auth.user.id
        })
        if(openActions.length > 0){
            openActions = openActions.sort(sortByDueDate)
            return openActions[0]
        } else {
            return null
        }
    } else {
        return null
    }
})

const nextActionDate = computed(() => {
    if(nextActionDue.value){
        return formatDateTwoDigitYear(nextActionDue.value.due_date)
    } else {
        return '--'
    }
})


function updateNextStep(field, value) {
    const detailData = {
        detailId: nextActionDue.value.id,
        field: field,
        value: value
    }
    emit('update-next-step', company.value.id, detailData)
}

function createNewDetail(detailTypeId) {
    const newActionData = {
        action_id: detailTypeId,
        action_notes: "",
        company_id: company.value.id,
        campaign_id: company.value.campaign.id,
        highlight_color: null,
        user: null,
        action: null,
        resolved_date: null,
        due_date: getTodaysDateAsString(),
        // due_date: new Date().toISOString().split('T')[0],
        id: Math.random()
    }
    emit('create-new-next-step', company.value.id, nextActionDue.value.id, newActionData)
}

function fetchNewCompanies(){
    emit('refetch-companies')
}

async function bulkUpdateCompanyCRM(actionRows) {
    console.log('action rows', actionRows)
    companyLoading.value = true
    changeCount.value += 1
    if(actionRows) {
        company.value.crm_actions = actionRows
        const payload = {
            token: store.state.auth.token,
            formData: JSON.stringify(
            {
                crm_actions: actionRows
            }),
            companyId: company.value.id
        }
        crmDetailsVisible.value = false
        openInEdit.value = false
        const response = await updateCompanyCRMActions(payload)
        if(response.status == 200) {
            changeCount.value -= 1
            if(changeCount.value < 1){
                $toast.open({
                    message: `Successfully Updated CRM Events for Company ${company.value.id}.`,
                    type: 'success',
                    duration: 5000
                })
                setCompany(response.data.company)
                companyLoading.value = false
            }
        } else {
            $toast.open({
                message: `Unable to Update CRM Events for Company ${company.value.id}`,
                type: 'error',
                duration: 20000
            })
        }
    } else {
        companyLoading.value = false
    }

}

function openCompanyModal(){
    companyModalVisible.value = true
}

function closeCompanyModal(){
    companyModalVisible.value = false
}



</script>